import { connect } from 'react-redux';
import { fetchActivity } from '../../../store/modules/activity';
import _ from 'lodash';

import Activity from '../components/Activity';

const mapActionCreators = {
  fetchActivity,
};

const mapStateToProps = state => ({
  activity: state.activity.activities[state.activity.current],
  activities: _.filter(state.activity.activities, ['deleted_at', null]),
  staffs: _.filter(state.staff.staffs, ['deleted_at', null]),
  fetching: state.activity.fetching,
  staffFetching: state.staff.fetching,
});

export default connect(mapStateToProps, mapActionCreators)(Activity);



// WEBPACK FOOTER //
// ./src/routes/Activity/containers/ActivityContainer.js